import * as timeFilters from './time'
import * as strFilters from './str'
import * as validateFilters from './validate'

export default {...timeFilters, ...strFilters,...validateFilters}





// WEBPACK FOOTER //
// ./src/common/filter/index.js